import React, { useState } from 'react';
import { Button, Input, useToasts } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  useGetTenantInfo,
  useResetHashKey,
} from 'routes/screens/settings/hooks';
import Icon from 'shared/components/Icon';
import Spacer from 'shared/components/Spacer';
import { FreshLink } from 'shared/styles';

const EmailHashKey = () => {
  const { t } = useTranslation();
  const [hashKey, setHashKey] = useState<string>('');
  const [showAPIForm, setShowAPIForm] = useState<boolean>(false);
  const [isCopyClicked, setIsCopyClicked] = useState<boolean>(false);
  const [, setToast] = useToasts();

  const { data: tenantinfo, isLoading: isTenantLoading } = useGetTenantInfo();
  const { mutate: generateHashKey, isLoading: resetloading } = useResetHashKey({
    setToast,
  });

  const toggleDisplay = () => {
    setShowAPIForm(true);
  };

  const onCopyClick = async (copiedData: string) => {
    const cb = navigator.clipboard;
    await cb.writeText(copiedData);
    setIsCopyClicked(true);
    setTimeout(() => {
      setIsCopyClicked(false);
    }, 1500);
  };

  React.useEffect(() => {
    if (tenantinfo?.secret_key) setHashKey(tenantinfo.secret_key);
    else showAPIForm && generateHashKey();
  }, [tenantinfo, showAPIForm]);

  return (
    <>
      {showAPIForm ? (
        <>
          <div className="custom-label">
            <div className="key">{t('forms.labels.email_hash_key')}</div>
            <FreshLink
              href="https://support.freshsurvey.io/en/support/solutions/articles/50000005392-encrypting-in-app-email-hash-in-web-app-embed-collector"
              rel="noreferrer"
            >
              {t('settings.account_info.sidebar.learn_more')}
            </FreshLink>
          </div>
          {!isTenantLoading && (
            <Container>
              <Input
                type="text"
                disabled
                value={hashKey}
                // label="Email hash key"
                endAdornment={
                  <Button
                    type="secondary"
                    className="copy"
                    disabled={isCopyClicked || isTenantLoading}
                    onClick={() => onCopyClick(hashKey)}
                  >
                    {isCopyClicked ? (
                      t('copied')
                    ) : (
                      <>
                        <Icon
                          glyph="copy"
                          width={12}
                          height={12}
                          viewBox="0 -1 14 16"
                        />
                      </>
                    )}
                  </Button>
                }
              />
              <Button
                inline
                type="secondary"
                className="reset-api-key"
                disabled={resetloading}
                onClick={() => generateHashKey()}
              >
                {t('reset')}
              </Button>
            </Container>
          )}
        </>
      ) : (
        <div className="show-hide" onClick={() => toggleDisplay()}>
          <Icon glyph="view" width={16} height={16} /> <Spacer x={0.2} />
          {t('forms.labels.show_email_hash_key')}
        </div>
      )}
    </>
  );
};

export default EmailHashKey;

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  input {
    width: 115px;
  }

  button.reset-api-key {
    margin-bottom: 1px;
  }
  button.copy {
    border: none;
    border-left: 1px solid #cfd7df;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  label {
    font-size: 14px !important;
    color: var(--color-smoke-700);
    font-weight: 500 !important;
  }
`;
